import { useState } from "react";
import { useFleetNavigate } from "lib/hooks/useFleetNavigate";

import { useMap } from "providers/navigation/MapProvider";

import DialogBox from "components/layout/DialogBox";
import FunctionalButton from "components/layout/FunctionalButton";
import MapCard from "components/navigation/map/MapCard";
import SearchBar from "components/layout/SearchBar";
import Spinner from "components/layout/loading/Spinner";
import Table from "components/layout/Table";
import AnimatedModal from "components/layout/motion/AnimatedModal";

import { ReactComponent as CreateIcon } from "assets/svgs/Plus.svg";
import { ReactComponent as DiagramViewIcon } from "assets/svgs/view/DiagramView.svg";
import { ReactComponent as FilterIcon } from "assets/svgs/search/Filter.svg";
import { ReactComponent as ListViewIcon } from "assets/svgs/view/ListView.svg";
import { ReactComponent as SortIcon } from "assets/svgs/search/Sort.svg";
import { ReactComponent as SyncIcon } from "assets/svgs/Reset.svg";

const MapPage = () => {
    const { maps, isLoadingMaps, setSelectedMap } = useMap();

    const [diagramViewState, setDiagramViewState] = useState(true);
    const [deleteMap, setDeleteMap] = useState(null);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const navigate = useFleetNavigate();

    const openDelete = (map) => {
        setDeleteMap(map);
        setDeleteOpen(true);
    };

    const closeDelete = () => {
        setDeleteOpen(false);
        window.setTimeout(() => setDeleteMap(null), 220);
    };
    return (
        <div className="page-with-top-bar flex flex-col items-center justify-start space-y-4 px-6 py-5">
            {isLoadingMaps ? (
                <>
                    <Spinner />
                </>
            ) : (
                <>
                    <div className="flex w-full  items-center justify-between border-b border-b-black70 py-2">
                        <p className="text-h3 cursor-pointer">All Map</p>
                        <div className="flex  items-center justify-between space-x-2">
                            <FunctionalButton
                                className="button"
                                title="Create"
                                icon={<CreateIcon className="w-4 md:w-3 tablet:w-3" />}
                                titleClassName="text-h5"
                            />
                            <FunctionalButton
                                className="button"
                                title="Sync"
                                icon={<SyncIcon className="w-4 md:w-3 tablet:w-3" />}
                                titleClassName="text-h5"
                            />
                        </div>
                    </div>
                    <div className="flex w-full  items-center justify-between">
                        <SearchBar className="w-60" />
                        <div className="flex  items-center space-x-4">
                            <FunctionalButton icon={<FilterIcon className="w-4" />} />
                            <FunctionalButton icon={<SortIcon className="w-4" />} />
                            <FunctionalButton
                                icon={
                                    diagramViewState ? (
                                        <ListViewIcon className="w-4" />
                                    ) : (
                                        <DiagramViewIcon className="w-4" />
                                    )
                                }
                                onClick={() => setDiagramViewState(!diagramViewState)}
                            />
                        </div>
                    </div>
                    {diagramViewState ? (
                        <div className="scroll-vertical grid w-full grid-cols-[repeat(auto-fill,minmax(17.5rem,1fr))] gap-2 transition-all">
                            {maps.map((map, id) => (
                                <MapCard
                                    key={id}
                                    {...map}
                                    onCardClick={() => {
                                        setSelectedMap(map);
                                        navigate("/map/edit");
                                    }}
                                    onDelete={() => openDelete(map)}
                                />
                            ))}
                        </div>
                    ) : (
                        <Table
                            className="max-h-[calc(100%-6.25rem)]"
                            headerNames={[
                                "Map",
                                "Floor",
                                "Location",
                                "Last Updated",
                                "Create Date",
                            ]}
                            data={maps}
                            dataRowOnClick={(data) => console.log(data)}
                            additionalActionType="delete"
                            dataRowAdditionalAction={(event, data) => openDelete(data)}
                        />
                    )}
                    <AnimatedModal visible={deleteOpen} onClose={closeDelete}>
                        <DialogBox
                            embedded
                            description={`Delete ${deleteMap?.map}?`}
                            subDescription={
                                "Note: Deleting map will affect some mission! Those mission will be disabled."
                            }
                            cancelButton={
                                <FunctionalButton
                                    title="Cancel"
                                    titleClassName="text-black60"
                                    className="cancel-button"
                                    onClick={closeDelete}
                                />
                            }
                            confirmButton={
                                <FunctionalButton
                                    title="Delete"
                                    className="confirm-button"
                                    onClick={closeDelete}
                                />
                            }
                            onClose={closeDelete}
                        />
                    </AnimatedModal>
                </>
            )}
        </div>
    );
};

export default MapPage;
